<script>
import { mapGetters } from 'vuex';

export default {
  name: 'ReportsFiltersInboxes',
  emits: ['inboxFilterSelection'],
  data() {
    return {
      selectedOption: null,
    };
  },
  computed: {
    ...mapGetters({
      options: 'inboxes/getInboxes',
      getInboxDisplayName: 'inboxMetadata/getInboxDisplayName',
    }),
    optionsWithDisplayNames() {
      return this.options.map(inbox => ({
        ...inbox,
        displayName: this.getInboxDisplayName(inbox.id) || inbox.name || 'Desconhecido',
      }));
    },
  },
  mounted() {
    this.$store.dispatch('inboxes/get');
  },
  methods: {
    handleInput() {
      this.$emit('inboxFilterSelection', this.selectedOption);
    },
  },
};
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      :placeholder="$t('INBOX_REPORTS.FILTER_DROPDOWN_LABEL')"
      label="displayName"
      track-by="id"
      :options="optionsWithDisplayNames"
      :option-height="24"
      :show-labels="false"
      @update:model-value="handleInput"
    />
  </div>
</template>
